"use client";
import { useEffect, useState } from 'react';
import CourseCard from './CourseCard';
import { getData } from '../../../funcs/api';
import { filterPublicCourses } from '../lib/courseVisibility';

export default function CoursesClientFallback() {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchCourses() {
            try {
                setLoading(true);
                const data = await getData('course', '_embed');
                setCourses(filterPublicCourses(Array.isArray(data) ? data : []));
                setError(null);
            } catch (err) {
                console.error('Client-side fetch error:', err);
                setError(err);
                setCourses([]);
            } finally {
                setLoading(false);
            }
        }

        fetchCourses();
    }, []);

    if (loading) {
        return (
            <div className="col-12 text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">جار التحميل...</span>
                </div>
                <p className="text-muted mt-3">جار تحميل الدورات...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="col-12">
                <div className="alert alert-warning text-center" role="alert">
                    <p className="mb-0">حدث خطأ في تحميل الدورات. يرجى المحاولة مرة أخرى لاحقاً.</p>
                </div>
            </div>
        );
    }

    if (courses.length === 0) {
        return (
            <div className="col-12 text-center py-5">
                <p className="text-muted">لا يوجد دورات متاحة حالياً.</p>
            </div>
        );
    }

    return (
        <>
            {courses.map((course) => (
                <div key={course.id} className="col">
                    <CourseCard course={course} />
                </div>
            ))}
        </>
    );
}
